// extracted by mini-css-extract-plugin
module.exports = {"show-more-button":"xacJ_","showMoreButton":"xacJ_"};